import { createContext, useContext } from 'react';
import * as setup from 'setup';

const defaultData = {
    finish: setup.finish,
    footer: setup.footer,
    general: setup.general,
    header: setup.header,
};

const ContentContext = createContext<ContentState>({} as ContentState);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }: ContentProviderProps) {
    return <ContentContext.Provider value={defaultData}>{children}</ContentContext.Provider>;
}
